export default function formatDuration(duration, format) {  
  const invalidDuration = (typeof duration !== 'number' || duration < 0);

  duration = Math.round(duration);
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;
  switch(format) {
    case 'm:ss':
      return (invalidDuration ?
              '-:--' :
              `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`);
    case 'hh:mm:ss':
      return (invalidDuration ? 
              '--:--:--' : 
              `${zeroPad(hours)}:${zeroPad(minutes)}:${zeroPad(seconds)}`);
    case 'hH mM sS':
      return (invalidDuration ?
              '-h -m --s' :
              `${hours > 0 ? hours + 'h' : ''} ${minutes}m ${zeroPad(seconds)}s`);
    default: 
      return '--:--';
  }
}

function zeroPad(number) {
  return number < 10 ? '0' + number : '' + number;
}